import { useMemo } from "react";
import { useWorkspaceCategories } from "./useWorkspaceCategories";

export const useCategoryNameMap = (workspaceId?: string): Record<string, string> => {
  const { workspaceCategories } = useWorkspaceCategories({
    workspaceId,
    includeAll: false,
  });

  const categoryNameMap = useMemo(() => {
    const map: Record<string, string> = {};
    workspaceCategories.forEach((category) => {
      map[category.tagCategoryId] = category.name;
    });
    return map;
  }, [workspaceCategories]);

  return categoryNameMap;
};
